module.exports = __webpack_public_path__ + "fdda0fa4057bbfb50563dc60d24bc064.mp4";